import { VAULT_APY_LABEL } from 'src/constants/vaults/misc';

function getApyOptions() {
	return [
		{ value: '7d', label: '7D' },
		{ value: '30d', label: '30D' },
		{ value: '90d', label: '90D' },
	];
}

const getApyPeriodLabel = (period: string) => {
	const apyOptions = getApyOptions();
	return (
		apyOptions.find((option) => option.value === period)?.label ||
		period.toUpperCase()
	);
};

export const getApyColumnHeader = (period = '90D') =>
	`${getApyPeriodLabel(period)} ${VAULT_APY_LABEL}`;
